import { SelectableBoxField } from '@flos/react-ui';
import { useMemo } from 'react';

type VehicleTypeSelectProps = {
    label: string;
    value: string;
    onChangeValue: (newEntity: string, newDisplayValue: string) => void;
};

const VehicleTypeSelect = (props: VehicleTypeSelectProps) => {
    const options = useMemo(
        () => [
            {
                label: 'Bil',
                value: 'personbil'
            },
            {
                label: 'MC/Knallert',
                value: 'knallert'
            },
            {
                label: 'Trailer',
                value: 'trailer'
            },
            {
                label: 'Campingvogn',
                value: 'campingvgn'
            },
            {
                label: 'Andet',
                value: 'others'
            }
        ],
        []
    );
    const handleChange = (newValue: string) => {
        props.onChangeValue(newValue, options.filter((o) => o.value === newValue).map((o) => o.label)[0]);
    };
    return (
        <SelectableBoxField
            value={props.value}
            onChangeValue={handleChange}
            options={options}
            label={props.label}
            required
        />
    );
};
export default VehicleTypeSelect;
